import React from "react";
import "./TodoFirst.css"

function TodoFirst(){
    return(
        <div className="TodoFirst">
            <p> Create your first task!</p>
            <img src="https://media.tenor.com/tqoX4Da8YmwAAAAM/doggo-dog.gif"></img>
        </div>
    );
}

export {TodoFirst}